// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/int64-lookup-schema',
  type: 'object',
  required: ['id', 'sort'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    caption: {
      type: 'string',
      nullable: true,
    },
    details: {
      type: 'string',
      nullable: true,
    },
    sort: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
